<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>SCHOLARSHIP</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Scholarship Detail</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="">
    <div class="container">
        <div class="section-heading">
            <h2 class="mb-9 display-16 display-sm-14 display-lg-10 font-weight-800">PB Scholarship</h2>
            <div class="heading-seperator"><span></span></div>
        </div>
        <table class="table table-responsive table-bordered">
            <thead style="background-color: #e67e22;color: white;">
            <tr>
                <th class="bg-secondary text-white text-center" style="width: 20%;">Punjab Scholarship Details</th>
                <th class="bg-secondary text-white text-center" style="width: 5%;">Download</th>
            </tr>
            </thead>
            <tbody style="background: aliceblue;color:#e67e22; font-weight: bold;">
            <tr>
                <td>SC/OBC Fresh 2014-15</td>
                <td><a href="assets/PBScholarship/sc obc Fresh 2014-15.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Fresh 2015-16</td>
                <td><a href="assets/PBScholarship/obc Fresh 2015-16.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Fresh 2016-17</td>
                <td><a href="assets/PBScholarship/obc Fresh 2016-17.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Fresh 2017-18</td>
                <td><a href="assets/PBScholarship/obc Fresh 2017-18.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC fresh 2018-19</td>
                <td><a href="assets/PBScholarship/obc fresh 2018-19.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC fresh 2019-20</td>
                <td><a href="assets/PBScholarship/obc fresh 2019-20.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC renewal 2015-16</td>
                <td><a href="assets/PBScholarship/obc renewal 2015-16.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC renewal 2016-17</td>
                <td><a href="assets/PBScholarship/obc renewal 2016-17.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC renewal 2017-18</td>
                <td><a href="assets/PBScholarship/obc renewal 2017-18.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>obc renewal 2018-19</td>
                <td><a href="assets/PBScholarship/obc renewal 2018-19.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC renewal 2019-20</td>
                <td><a href="assets/PBScholarship/obc renewal 2019-20.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2015-16</td>
                <td><a href="assets/PBScholarship/sc Fresh 2015-16.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2016-17</td>
                <td><a href="assets/PBScholarship/sc Fresh 2016-17.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2017-18</td>
                <td><a href="assets/PBScholarship/sc Fresh 2017-18.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC fresh 2018-19</td>
                <td><a href="assets/PBScholarship/sc fresh 2018-19.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC fresh 2019-20</td>
                <td><a href="assets/PBScholarship/sc fresh 2019-20.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC renewal 2015-16</td>
                <td><a href="assets/PBScholarship/sc renewal 2015-16.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC renewal 2016-17</td>
                <td><a href="assets/PBScholarship/sc renewal 2016-17.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC renewal 2016-17</td>
                <td><a href="assets/PBScholarship/sc renewal 2016-17.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>sc renewal 2017-18</td>
                <td><a href="assets/PBScholarship/sc renewal 2017-18.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC renewal 2018-19</td>
                <td><a href="assets/PBScholarship/sc renewal 2018-19.pdf" target="_blank">Download</a></td>
            </tr>
            </tbody>
        </table>

        <div class="section-heading">
            <h2 class="mb-9 display-16 display-sm-14 display-lg-10 font-weight-800">HP Scholarship</h2>
            <div class="heading-seperator"><span></span></div>
        </div>
        <table class="table table-responsive table-bordered">
            <thead style="background-color: #e67e22;color: white;">
            <tr>
                <th class="bg-secondary text-white text-center" style="width: 20%;">Himachal Scholarship Details</th>
                <th class="bg-secondary text-white text-center" style="width: 20%;">Download</th>
            </tr>
            </thead>
            <tbody style="background: aliceblue;color:#e67e22; font-weight: bold;">
            <tr>
                <td>OBC Fresh 2020-21</td>
                <td><a href="assets/HPScholarship/fresh 2020-21.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Fresh 2015</td>
                <td><a href="assets/HPScholarship/obc fresh 2015.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Fresh 2016</td>
                <td><a href="assets/HPScholarship/obc fresh 2016.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Fresh 2017</td>
                <td><a href="assets/HPScholarship/obc fresh 2017.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Fresh 2018</td>
                <td><a href="assets/HPScholarship/obc fresh 2018.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC ST OBC Fresh 2019</td>
                <td><a href="assets/HPScholarship/sc st obc fresh 2019.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Renewal 2016</td>
                <td><a href="assets/HPScholarship/obc renewal 2016.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Renewal 2017</td>
                <td><a href="assets/HPScholarship/obc renewal 2017.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Renewal 2018</td>
                <td><a href="assets/HPScholarship/obc renewal 2018.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>OBC Renewal 2020-21</td>
                <td><a href="assets/HPScholarship/renewal 2020-21.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2014</td>
                <td><a href="assets/HPScholarship/SC Fresh 2014.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2015</td>
                <td><a href="assets/HPScholarship/sc fresh 2015.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2016</td>
                <td><a href="assets/HPScholarship/sc fresh 2016.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2017</td>
                <td><a href="assets/HPScholarship/sc fresh 2017.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Fresh 2018</td>
                <td><a href="assets/HPScholarship/sc fresh 2018.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Renewal 2015</td>
                <td><a href="assets/HPScholarship/SC Renewal 2015.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Renewal 2016</td>
                <td><a href="assets/HPScholarship/sc renewal 2016.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Renewal 2017</td>
                <td><a href="assets/HPScholarship/sc renewal 2017.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>SC Renewal 2018</td>
                <td><a href="assets/HPScholarship/sc renewal 2018.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>ST Fresh 2014</td>
                <td><a href="assets/HPScholarship/ST 2014.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>ST Fresh 2015</td>
                <td><a href="assets/HPScholarship/ST fresh 2015.pdf" target="_blank">Download</a></td>
            </tr>


            <tr>
                <td>ST Fresh 2016</td>
                <td><a href="assets/HPScholarship/ST 2016.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>ST Fresh 2017</td>
                <td><a href="assets/HPScholarship/ST fresh 2017.pdf" target="_blank">Download</a></td>
            </tr>

            <tr>
                <td>ST Fresh 2018</td>
                <td><a href="assets/HPScholarship/ST Fresh 2018.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>ST Renewal 2015</td>
                <td><a href="assets/HPScholarship/ST renewal 2015.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>ST Renewal 2016</td>
                <td><a href="assets/HPScholarship/ST renewal 2016.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>ST Renewal 2017</td>
                <td><a href="assets/HPScholarship/st renewal 2017.pdf" target="_blank">Download</a></td>
            </tr>
            <tr>
                <td>ST Renewal 2018</td>
                <td><a href="assets/HPScholarship/st renewal 2018pdf" target="_blank">Download</a></td>
            </tr>
            </tbody>
        </table>
    </div>
</section>
